(function() {
    'use strict';

    angular.module("imApp").factory("checkInStatusService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1511,
                    parameters: parms || {}
                });
            },
            listCheckInStatuses: function (parms) {
                return $ihttp.post({
                    method: 508,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
